
import { Component, Vue } from "vue-property-decorator";
import AdminTable from "@/components/admin/AdminTable.vue";
import AdminSkinCell from "@/components/admin/AdminSkinCell.vue";

@Component({
  components: {
    AdminTable,
    AdminSkinCell
  }
})
export default class AdminSteamItem extends Vue {
  // Вкладки: все скины (по умолчанию), по игре и нестабильные (по всем играм)
  tabs = [
    {
      name: "all",
      label: "Все",
      icon: "fas fa-layer-group",
      condition: {}
    },
    {
      name: "cs2",
      label: "CS2",
      img: "/assets/csgo-icon2.svg",
      imgClass: "admin-table-tab__img--wide",
      condition: { appId: 730 }
    },
    {
      name: "dota2",
      label: "Dota 2",
      img: "/assets/dota2-icon.svg",
      condition: { appId: 570 }
    },
    {
      name: "tf2",
      label: "TF2",
      img: "/assets/tf2-icon.png",
      condition: { appId: 440 }
    },
    {
      name: "unstable",
      label: "Unstable",
      icon: "fas fa-exclamation-triangle",
      accent: "warning",
      condition: { unstable: true }
    }
  ];

  columns = [
    {
      name: "_id",
      required: true,
      label: "name",
      field: "_id",
      align: "left",
      type: "string"
    },
    {
      // Фаза доплера: у фазового варианта _id = "<baseName> - <phase>"
      name: "phase",
      label: "phase",
      field: "phase",
      align: "left",
      type: "string"
    },
    /*{
      name: "baseName",
      label: "baseName",
      field: "baseName",
      align: "left",
      type: "string"
    },*/
    {
      name: "price",
      required: true,
      label: "price",
      field: "price",
      sortable: true,
      align: "left",
      type: "number",
      editable: true
    },
    {
      name: "testPrice",
      required: true,
      label: "testPrice",
      field: "testPrice",
      sortable: true,
      align: "left",
      type: "number",
      editable: true
    },
    {
      name: "appId",
      required: true,
      label: "appId",
      field: "appId",
      align: "left",
      type: "number"
    },

    {
      name: "fixed",
      align: "center",
      label: "fixed",
      field: "fixed",
      editable: true,
      type: "boolean"
    },
    {
      name: "unstable",
      align: "center",
      label: "unstable",
      field: "unstable",
      editable: true,
      type: "boolean"
    },
    {
      name: "unstableOnBuyServer",
      align: "center",
      label: "unstableOnBuyServer",
      field: "unstableOnBuyServer",
      editable: true,
      type: "boolean"
    },
    {
      name: "buyUnstableReasons",
      align: "center",
      label: "buyUnstableReasons",
      field: "buyUnstableReasons",
      type: "chip-array"
    },
    {
      name: "unstableOnBuyServerByYesterday",
      align: "center",
      label: "unstableOnBuyServerByYesterday",
      field: "unstableOnBuyServerByYesterday",
      editable: true,
      type: "boolean"
    },
    {
      name: "unstableByApi",
      align: "center",
      label: "unstableByApi",
      field: "unstableByApi",
      editable: false,
      type: "boolean"
    },
    {
      name: "banned",
      align: "center",
      label: "banned",
      field: "banned",
      editable: true,
      type: "boolean"
    },
    {
      name: "dailyBanned",
      align: "center",
      label: "dailyBanned",
      field: "dailyBanned",
      editable: true,
      type: "boolean"
    },
    {
      name: "weeklyBanned",
      align: "center",
      label: "weeklyBanned",
      field: "weeklyBanned",
      editable: true,
      type: "boolean"
    },
    {
      name: "monthlyBanned",
      align: "center",
      label: "monthlyBanned",
      field: "monthlyBanned",
      editable: true,
      type: "boolean"
    },
    {
      name: "moderation",
      align: "center",
      label: "moderation",
      field: "moderation",
      editable: true,
      type: "boolean"
    },
    {
      name: "priceBeforeModeration",
      align: "center",
      label: "priceBeforeModeration",
      field: "priceBeforeModeration",
      editable: false,
      type: "number"
    },
    {
      name: "rarity",
      label: "rarity",
      field: "rarity",
      align: "left",
      type: "string"
    },
    {
      name: "rarityColor",
      label: "rarityColor",
      field: "rarityColor",
      align: "left",
      type: "string"
    },
    {
      name: "updatedAt",
      align: "center",
      label: "updatedAt",
      field: "updatedAt",
      editable: true,
      type: "string"
    }
  ];
}
